import { render, staticRenderFns } from "./StudentBeRepeated.vue?vue&type=template&id=e684417a&"
import script from "./StudentBeRepeated.vue?vue&type=script&lang=js&"
export * from "./StudentBeRepeated.vue?vue&type=script&lang=js&"
import style0 from "./StudentBeRepeated.vue?vue&type=style&index=0&id=e684417a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports